/** @jsx jsx */
import { jsx } from "@emotion/core";
import React from "react";
import { style } from "./style";
export class PrivacyImage extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            mask: true
        };
    }
    hidePrivacyMask() {
        this.setState({
            mask: false
        }, () => {
            this.props.onHide && this.props.onHide();
        });
    }
    render() {
        return (jsx("div", { className: this.props.className || "", css: style.contain },
            jsx("div", { css: this.state.mask ? style.filter : null }, this.props.children),
            this.state.mask ? (jsx("div", { css: style.mask, onClick: this.hidePrivacyMask.bind(this) },
                jsx("img", { css: style.eye, src: require("../../../assets/image/icon.png"), alt: "" }),
                jsx("div", { css: style.text }, "\u67E5\u770B"))) : null));
    }
}
